import { filterEditorState } from './filterEditorState';
import { InlineToolbarButtons, Plugins } from '../../DaEditor/enums';
export function stripFormattingForEditorFlavour(config, editorState) {
    const filterConfig = flavourConfigToFilterConfig(config);
    return filterEditorState(filterConfig, editorState);
}
const textToolToConfig = {
    blockquote: InlineToolbarButtons.BLOCKQUOTE,
    'unordered-list-item': InlineToolbarButtons.UNORDERED_LIST,
    'ordered-list-item': InlineToolbarButtons.ORDERED_LIST,
    'inline-header-two': InlineToolbarButtons.TITLE,
    'inline-header-three': InlineToolbarButtons.TITLE,
    BOLD: InlineToolbarButtons.BOLD,
    ITALIC: InlineToolbarButtons.ITALIC,
    UNDERLINE: InlineToolbarButtons.UNDERLINE,
    'header-two': InlineToolbarButtons.TITLE,
    'header-three': InlineToolbarButtons.TITLE,
    TEXT_COLOR: InlineToolbarButtons.TEXT_COLOR
};
const pluginToConfig = {
    LINK: Plugins.LINK,
    'wix-draft-plugin-link-preview': Plugins.LINK_PREVIEW,
    'wix-draft-plugin-divider': Plugins.DIVIDER,
    'wix-draft-plugin-gallery': Plugins.GALLERY,
    'wix-draft-plugin-image': Plugins.IMAGE,
    DA_OFF_EMOTE: Plugins.EMOTES,
    DA_COMM_EMOTE: Plugins.EMOTES,
    mention: Plugins.MENTION,
    'wix-draft-plugin-video': Plugins.VIDEO,
    'wix-draft-plugin-giphy': 'wix-draft-plugin-giphy',
    DND_UPLOAD: Plugins.DND_UPLOAD,
    EMOJI_TYPE: Plugins.EMOJI
};
const entityConfig = {
    LINK: {
        type: 'LINK',
        attributes: [
            'url'
        ]
    },
    'wix-draft-plugin-link-preview': {
        type: Plugins.LINK_PREVIEW
    },
    'wix-draft-plugin-divider': {
        type: Plugins.DIVIDER
    },
    'wix-draft-plugin-gallery': {
        type: 'wix-draft-plugin-gallery'
    },
    'wix-draft-plugin-image': {
        type: 'wix-draft-plugin-image'
    },
    DA_OFF_EMOTE: {
        type: 'DA_OFF_EMOTE'
    },
    DA_COMM_EMOTE: {
        type: 'DA_COMM_EMOTE'
    },
    mention: {
        type: 'mention'
    },
    'wix-draft-plugin-video': {
        type: 'wix-draft-plugin-video'
    },
    'wix-draft-plugin-giphy': {
        type: 'wix-draft-plugin-giphy'
    },
    DND_UPLOAD: {
        type: 'DND_UPLOAD'
    },
    EMOJI_TYPE: {
        type: 'EMOJI_TYPE'
    }
};
function flavourConfigToFilterConfig(config) {
    const blocks = [
        'unordered-list-item',
        'ordered-list-item',
        'blockquote',
        'header-two',
        'header-three'
    ].filter((block)=>config.textTools.find((t)=>t === textToolToConfig[block]));
    const styles = [
        'inline-header-two',
        'inline-header-three',
        'BOLD',
        'ITALIC',
        'UNDERLINE',
        'TEXT_COLOR'
    ].filter((style)=>config.textTools.find((t)=>t === textToolToConfig[style]))// For now we have a single special case for text tools, if this changes
    // please refactor this.
    .map((style)=>{
        return style === 'TEXT_COLOR' ? /^{"FG":/i : new RegExp(`^${style}$`);
    });
    const entities = [
        'LINK',
        'wix-draft-plugin-link-preview',
        'wix-draft-plugin-divider',
        'wix-draft-plugin-gallery',
        'wix-draft-plugin-image',
        'DA_OFF_EMOTE',
        'DA_COMM_EMOTE',
        'mention',
        'wix-draft-plugin-video',
        'wix-draft-plugin-giphy',
        'DND_UPLOAD',
        'EMOJI_TYPE'
    ].filter((entityType)=>config.pluginsConfig[pluginToConfig[entityType]]).map((entityType)=>entityConfig[entityType]);
    return {
        blocks,
        styles,
        entities,
        maxNesting: 5,
        whitespacedCharacters: [
            '📷'
        ]
    };
}
